import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    if (name === 'Whatsapp') {
        return (
            <svg
                viewBox="0 0 24 24"
                width={size}
                height={size}
                fill={color}
                className={className}
                aria-hidden="true"
                {...props}
            >
                <path d="M12.04 2C6.62 2 2.2 6.42 2.2 11.84c0 1.94.5 3.84 1.46 5.52L2 22l4.82-1.58c1.62.88 3.44 1.34 5.31 1.34h.01c5.42 0 9.84-4.42 9.84-9.84 0-2.63-1.02-5.1-2.88-6.96A9.79 9.79 0 0 0 12.04 2zm5.7 14.07c-.24.67-1.38 1.27-1.92 1.35-.52.08-1.18.12-1.9-.12-.44-.14-1.01-.33-1.74-.64-3.07-1.33-5.08-4.42-5.24-4.63-.16-.21-1.25-1.66-1.25-3.18 0-1.52.8-2.26 1.08-2.57.28-.3.62-.38.83-.38.2 0 .41 0 .59.01.19.01.44-.07.69.53.24.6.84 2.07.91 2.22.07.15.12.33.03.54-.1.21-.15.33-.3.5-.15.17-.31.38-.44.51-.15.15-.31.31-.13.62.18.31.8 1.33 1.72 2.15 1.18 1.06 2.18 1.39 2.49 1.55.31.16.49.14.67-.09.18-.22.77-.89.97-1.19.2-.3.41-.25.69-.15.28.1 1.77.83 2.07.98.31.15.51.22.58.35.07.13.07.77-.17 1.44z" />
            </svg>
        );
    }

    const IconComponent = LucideIcons?.[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;